import {createSlice} from "@reduxjs/toolkit";

import chapterCompleted from "../chapters/chapterCompleted";

type State = {
	byKey: {
		[chapterKey: string]: {status?: "showing" | "closed"} | undefined;
	};
};

const initialState: State = {
	byKey: {},
};

export const chapterCompletionRewardSlice = createSlice({
	name: "chapterCompletionReward",
	initialState,
	reducers: {
		markShown: (state, {payload}) => {
			state.byKey[payload.chapterKey] = {status: "closed"};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(chapterCompleted, (state, {payload}) => {
			if (!state.byKey[payload.chapterKey]) {
				state.byKey[payload.chapterKey] = {status: "showing"};
			}

			return state;
		});
	},
});

export const {
	markShown: markChapterCompletionRewardShown,
} = chapterCompletionRewardSlice.actions;

export default chapterCompletionRewardSlice.reducer;
